import { z } from 'zod';

export const DataFilterConditionsSchema = z.enum(['Empty','NotEmpty','Any','NotAny','Contains','NotContains','StartsWith','Equal','NotEqual','LessThan','LessThanOrEqual','GreaterThan','GreaterThanOrEqual','IsBefore','IsAfter','IsBeforeOrEqual','IsAfterOrEqual','IsBetween','CurrentDay','CurrentWeek','CurrentMonth','DaysAgo','WeeksAgo','MonthsAgo','YearsAgo','DaysAhead','WeeksAhead','MonthsAhead','YearsAhead']);

export type DataFilterConditionsType = `${z.infer<typeof DataFilterConditionsSchema>}`

export default DataFilterConditionsSchema;
